import Lib from '../../commons/lib';

export default class Service {
  static teremberlesUrl = window.location.origin + '/api/teremberles/';

  static partnerUrl = window.location.origin + '/api/partner/';

  // TEREMBERLES START

  static listTeremberles(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.teremberlesUrl + 'teremberles/list',
          args: { requestType: 'teremberles-list' }
        }
      ],
      fnDone
    );
  }

  static initTeremberles(id, fizetesiModAzonositok, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.teremberlesUrl + 'teremberles/init',
          args: { requestType: 'teremberles-init' },
          params: { id },
          data: fizetesiModAzonositok
        }
      ],
      fnDone
    );
  }

  static initTeremberlesFizetes(id, fizetesiModAzonositok, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.teremberlesUrl + 'teremberles/init/pay',
          args: { requestType: 'teremberles-init-pay' },
          params: { id: id },
          data: fizetesiModAzonositok
        }
      ],
      fnDone
    );
  }

  static initTeremberlesFizetesView(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.teremberlesUrl + 'teremberles/init/pay/view',
          args: { requestType: 'teremberles-init-pay' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static addTeremberles(submitObj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.teremberlesUrl + 'teremberles',
          args: { requestType: 'teremberles-post' },
          data: submitObj
        }
      ],
      fnDone
    );
  }

  static modifyTeremberles(submitObj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.teremberlesUrl + 'teremberles',
          args: { requestType: 'teremberles-put' },
          data: submitObj
        }
      ],
      fnDone
    );
  }

  static deleteTeremberles(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.teremberlesUrl + 'teremberles',
          args: { requestType: 'teremberles-delete' },
          params: { id }
        }
      ],
      fnDone
    );
  }

  static getTeremberles(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.teremberlesUrl + 'teremberles',
          args: { requestType: 'teremberles-get' },
          params: { id }
        }
      ],
      fnDone
    );
  }

  static searchPartner(type, text, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.partnerUrl + 'search',
      args: { requestType: 'partner-search' },
      params: {
        type: type,
        text: text
      }
    }], fnDone);
  }

  static initPartnerInsert(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.teremberlesUrl + 'teremberles/initpartner',
          args: { requestType: 'partner-initbase' }
        }
      ],
      fnDone
    );
  }

  static insertPartner(helyszinId, submitObj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.teremberlesUrl + 'teremberles/partner',
          args: { requestType: 'teremberles-partner' },
          data: submitObj,
          params: {
            id: helyszinId
          }
        }
      ],
      fnDone
    );
  }

  static modifyTeremberlesFizetes(id, bizonylatszam, fizetesiModId, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.teremberlesUrl + 'teremberles/pay',
          args: { requestType: 'teremberles-pay' },
          params: {
            id: id,
            bsz: bizonylatszam,
            fiz: fizetesiModId
          }
        }
      ],
      fnDone
    );
  }

  static setGDPRHozzajarulas(id, op, data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.partnerUrl + 'gdprhozzaj',
      data: data,
      args: { requestType: 'jogalap-hozzajarul-put' },
      params: {
        id: id,
        op: op
      },
    }], fnDone);
  }

  static pdfGDPRGenerate(pid, nev, jid, cid, begin, end, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.partnerUrl + 'gdprhozzaj/pdf',
      args: { requestType: 'jogalap-pdf-kuld' },
      acceptType: 'application/json; charset=utf-8, text/plain; charset=utf-8, application/octet-stream',
      params: {
        pid, nev, jid, cid, begin, end
      },
    }], fnDone);
  }

  static deletePartner(partnerId, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.partnerUrl + 'partner',
      args: { requestType: 'partner-delete' },
      params: {
        id: partnerId
      }
    }], fnDone);
  }

  // TEREMBERLES END
}
